export default class LocalStorageService {
  prefix = 'eminza';

  api = localStorage;

  private prefixKey(plainKey: string): string {
    if (this.prefix) {
      return `[${this.prefix}]${plainKey}`;
    }

    return plainKey;
  }

  public setItem(key: string, data: any): void {
    this.api.setItem(this.prefixKey(key), JSON.stringify(data));
  }

  public getItem<T>(key: string): T | null {
    const data: string | null = this.api.getItem(this.prefixKey(key));

    if (data !== null) {
      return JSON.parse(data);
    }

    return null;
  }

  public removeItem(key: string): void {
    this.api.removeItem(this.prefixKey(key));
  }

  public clear(): void {
    this.api.clear();
  }
}
